/* istanbul ignore file */
import { boolean as codecBoolean, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const Patch1P1ProviderLTIDataParser = 
/* #__PURE__ */ parsers.object([
    ['finalize', /* #__PURE__ */ codecOptional(codecBoolean)],
]);
export class Patch1P1ProviderLTIData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return Patch1P1ProviderLTIDataParser.decode(input).map(res => new Patch1P1ProviderLTIData(res));
    }
    static unsafeDecode(input) {
        return Patch1P1ProviderLTIData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return Patch1P1ProviderLTIDataParser.encode(data);
    }
    static schema() {
        return Patch1P1ProviderLTIDataParser.schema();
    }
}
